import { jsx as _jsx } from "react/jsx-runtime";
export const DatePickerSkeleton = () => _jsx("div", { className: "v-date-picker v-date-picker--skeleton" });
DatePickerSkeleton.displayName = 'DatePickerSkeleton';
